import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonVariant } from './_types';
import { blockingReasonTranslationKey } from './blockingReasonTranslationKey';

export function CustomBlockingReason({
  actions,
  title,
  message,
  variant = 'checkin',
}: {
  actions?: ButtonPropsWithLabel[];
  title?: string;
  message?: string;
  variant?: BlockingReasonVariant;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={
        title || t(blockingReasonTranslationKey(variant, 'custom', 'title'))
      }
      message={
        message || t(blockingReasonTranslationKey(variant, 'custom', 'message'))
      }
      actions={actions}
    />
  );
}
